export enum Role {
  Participant = 'participant',
  Admin = 'admin',
  SuperAdmin = 'super_admin',
  InternalAdmin = 'internal_admin',
}
